//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('@/tbs/controller/BaseMediator')
const ClassFunc = require('@/tbs/util/ClassFunc')
const ObjectFunc = require('@/tbs/util/ObjectFunc')
const MatchBrandSortTimeConvertor = require('@/tbs/model/vo/MatchBrandSortTime')
const DataConvertor = require('@/tbs/core/DataConvertor')
// const ModelLocator = require('@/tbs/model/ModelLocator')

/**
 * The MatchMediator class maintains the business logic
 * for the organization.
 */
const tbs_controller_MatchBrandMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseMediator, arguments)
    // console.log('tbs_controller_MatchBrandMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_MatchBrandMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    /**
     * @api
     * Handle the creation complete condition triggered by 
     * the scene instance.
     */
    handleCreationComplete: function() {
        // console.log('handleCreationComplete')
        if (this._bridge.isCreate()) {
            this.fetchCityRegion()
            this.p_target().matchBrand.organizationId = this._bridge.getRouteQuery('organizationId')
            this.p_target().matchBrand.area = this._bridge.getRouteQuery('organizationArea')
            this.p_target().matchBrand.areaId = this._bridge.getRouteQuery('organizationAreaId')
        }
        else if (this._bridge.isEdit()) {
            this.fetchCityRegion()
            this.creationComplete()
        }
        else if (this._bridge.isDetail()) {
            this.creationComplete()
        }
        else if (this._bridge.isList()) {
            this.creationComplete({parameters: {orgId: this._bridge.getRouteQuery('organizationId')}})
            if (this._bridge.getRouteQuery('matchBrandId')) {
                this.p_target().selectedMatchBrandId = this._bridge.getRouteQuery('matchBrandId')
            }
        }
    },
    /**
     * @api
     * Handle the custom event condition triggered by 
     * the scene instance.
     * @event The event object contains 
     * {type:String, data:Object, target:VueComponent}
     */
    handleCustomEvent: function(event) {
        console.log('handleCustomEvent', event)
        if (event.type == 'save') {
            this.submitData(event.target, event.data, true)
        }
        else if (event.type == 'submit') {
            this.submitData(event.target, event.data)
        }
        else if (event.type == 'delete') {
            this.deleteRecord(event.target, event.data)
        }
        else if (event.type == 'navigate') {
            const organizationQuery = {
                organizationId: this._bridge.getRouteQuery('organizationId'),
                organizationName: this._bridge.getRouteQuery('organizationName'),
                organizationLogoUrl: this._bridge.getRouteQuery('organizationLogoUrl'),
                organizationAreaId: this._bridge.getRouteQuery('organizationAreaId'),
                organizationArea: this._bridge.getRouteQuery('organizationArea'),
            }
            if (this._bridge.getRouteQuery('hideOrg')) {
                organizationQuery.hideOrg = 'true'
            }
            ObjectFunc.mergeObject(organizationQuery, {from: this._bridge.getRouteQuery('from')})
            this._bridge.goToScene(event.data.name, event.data.params, 
                ObjectFunc.mergeObject(organizationQuery, event.data.query))
        }
        else if (event.type == 'itemClick') {
            // save the click behavior on the server side
            this.changeMatchBrandSortTime(event.data.matchBrandId)
            const from = this._bridge.getRouteQuery('from')
            const matchId = this._bridge.getRouteQuery('matchId')
            if (from == 'OrgEditMatch') {
                this._bridge.goToScene(from, 
                    {id: matchId}, event.data)
            }
            else if (from == 'OrgCreateMatchName') {
                const organizationQuery = {
                    hideOrg: this._bridge.getRouteQuery('hideOrg'),
                    organizationId: this._bridge.getRouteQuery('organizationId'),
                    organizationName: this._bridge.getRouteQuery('organizationName'),
                    organizationLogoUrl: this._bridge.getRouteQuery('organizationLogoUrl'),
                    organizationAreaId: this._bridge.getRouteQuery('organizationAreaId'),
                    organizationArea: this._bridge.getRouteQuery('organizationArea'),   
                }
                this._bridge.goToScene(from, 
                    null, ObjectFunc.mergeObject(organizationQuery, event.data))
            }
            else if (from == 'OrgManageOrganization') {
                this._bridge.goToScene('OrgCreateMatchName', null, ObjectFunc.mergeObject(this._bridge.getRouteQuery(), event.data))
            }
        }
    },
    handleCreateService: function(e)  {
        if (e.data.result == true) {
            console.log('handleCreateMethod', e.data)
            // ModelLocator.setStatus('organizationName', e.data.options.organizationName)
            // ModelLocator.setStatus('organizationLogoUrl', e.data.options.organizationLogoUrl)
            const from = this._bridge.getRouteQuery('from')
            const matchBrandId = e.data.payload.data.brandId
            if (from == 'OrgCreateMatchName') {
                const query = {
                    matchBrandId: matchBrandId,
                    matchBrandName: e.data.options.data.name,
                    matchBrandLogoUrl: e.data.options.data.logo,
                    matchBrandAreaId: e.data.options.data.areaId,
                    matchBrandArea: e.data.options.data.area,
                    organizationId: this._bridge.getRouteQuery('organizationId'),
                    organizationName: this._bridge.getRouteQuery('organizationName'),
                    organizationLogoUrl: this._bridge.getRouteQuery('organizationLogoUrl'),
                    organizationAreaId: this._bridge.getRouteQuery('organizationAreaId'),
                    organizationArea: this._bridge.getRouteQuery('organizationArea'),
                }
                if (this._bridge.getRouteQuery('hideOrg')) {
                    query.hideOrg = 'true'
                }
                // save the click behavior on the server side
                // @tmp no match brand id return
                this.changeMatchBrandSortTime(matchBrandId)
                this._bridge.goToScene(from, null, query)
            }
            else if (from == 'OrgEditMatch') {
                // save the click behavior on the server side
                this.changeMatchBrandSortTime(matchBrandId)
                this._bridge.goToScene(from, this._bridge.getRouteParam('id'))
            }
        }
    },
    handleRemoveService: function(e) {
        console.log('handleRemoveService in MatchBrandMediator', e)
        this._bridge.back(-2)
    },
    changeMatchBrandSortTime: function(matchBrandId) {
        const self = this
        const convertor = new MatchBrandSortTimeConvertor()
        const source = convertor.view.update
        const service = 'updateMatchBrandSortTime'
        const postBody = DataConvertor.transform(convertor, {matchBrandId: matchBrandId}, 'update')
        self._bridge.addResourceListener(service, function(e) {
            self._bridge.removeResourceListener(service, e.handler)
            console.log('update.data', service, e.data)
        })
        self._bridge.callResourceInstance(service, {
            baseUrl: source.baseUrl,
            apiPrefix: source.apiPrefix,
            apiSuffix: source.apiSuffix,
            serviceName: source.service,
            method: 'POST',
            data: postBody
        })
    },
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_MatchBrandMediator, BaseMediator);

module.exports = tbs_controller_MatchBrandMediator